import { httpGet, httpPost, httpPut } from '../../../Util/http';
import { addAlert } from '../../../MsgNotify/msgNotifyActions';


export const FETCH_CHATMESSAGE_REQUEST = 'FETCH_CHATMESSAGE_REQUEST'
export const fetchChatmessagesRequest = () => {
    return {
        type: FETCH_CHATMESSAGE_REQUEST
    }
}

export const FETCH_CHATMESSAGE_SUCCESS_INIT = 'FETCH_CHATMESSAGE_SUCCESS_INIT'
export const fetchChatmessagesSuccessInit = (json) => {
    return {
        type: FETCH_CHATMESSAGE_SUCCESS_INIT,
        chatMessages: json.chatMessages
    }
}


export const FETCH_CHATMESSAGE_SUCCESS = 'FETCH_CHATMESSAGE_SUCCESS'
export const fetchChatmessagesSuccess = (json) => {
    return {
        type: FETCH_CHATMESSAGE_SUCCESS,
        chatMessages: json.chatMessages
    }
}

export const FETCH_CHATMESSAGE_FAILURE = 'FETCH_CHATMESSAGE_FAILURE'
export const fetchChatmessagesFailure = () => {
    return {
        type: FETCH_CHATMESSAGE_FAILURE
    }
}

export const fetchChatMessages = (activityId, startingFrom, init = false) => {
    /*HACK to remove double quotes from json date
    see: http://weblog.west-wind.com/posts/2014/Jan/06/JavaScript-JSON-Date-Parsing-and-real-Dates*/
    var _url = process.env.REACT_APP_webApiEndPoint + "api/chat/" + activityId + "/" + startingFrom;
    return dispatch => {
        dispatch(fetchChatmessagesRequest());
        return httpGet(_url)
            .then(response => {
                return response.json();
            })
            .then(json => {
                if (json.chatMessages.length === 0) {
                    dispatch({
                        type: 'NO_MORE_CHAT_MESSAGES',
                    })
                }
                if (init)
                    dispatch(fetchChatmessagesSuccessInit(json))
                else
                    dispatch(fetchChatmessagesSuccess(json))
            })
            .catch((e) => {
                //TODO pushpath to previous kanban overview
                dispatch(fetchChatmessagesFailure());
                dispatch(addAlert(e.message))
            })
    };
}


export const ADD_MESSAGE_REQUEST = 'ADD_MESSAGE_REQUEST'
export const addMessageRequest = (message, fullName) => {
    return {
        type: ADD_MESSAGE_REQUEST,
        chatMessage: {
            message: message,
            fullName: fullName,
            id: Math.random(),
            date: 'I dag',
            time: 'Nu'
        }
    }
}

export const ADD_MESSAGE_SUCCESS = 'ADD_MESSAGE_SUCCESS'
export const addMessageSuccess = () => {
    return {
        type: ADD_MESSAGE_SUCCESS
    }
}

export const ADD_MESSAGE_FAILURE = 'ADD_MESSAGE_FAILURE'
export const addMessageFailure = () => {
    return {
        type: ADD_MESSAGE_FAILURE
    }
}

export const addChatMessage = (message, fullName, activityId) => {
    return (dispatch) => {
        dispatch(addMessageRequest(message, fullName));
        var _url = process.env.REACT_APP_webApiEndPoint + "api/chat/" + activityId;
        return httpPost(_url, { message: message })
            .then(() => {
                dispatch(addMessageSuccess());
            })
            .catch(() => {
                dispatch(addMessageFailure())
                dispatch(addAlert("Din kommentar kunne ikke gemmes"))
            })
    };
}


export const addReadChatMessage = (activityId, chatMessage) => {
    return (dispatch) => {
        dispatch(addMessageRequest(chatMessage.message, chatMessage.fullName));
        var _url = process.env.REACT_APP_webApiEndPoint + "api/chat/" + activityId + "/read";
        return httpPut(_url, { activityId: activityId })
            .then(response => {
                if (response.status >= 400) {
                    throw new Error("Kunne ikke sætte besked som læst");
                }
                return response;
            })
            .catch(() => {
            })
    };
}



// WEBPACK FOOTER //
// ./src/App/Project/RegisterActivities/Chat/actions.js